
<svg width="24px" height="24px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <!-- Generator: Sketch 50.2 (55047) - http://www.bohemiancoding.com/sketch -->
    <desc>Created with Sketch.</desc>
    <defs></defs>
    <g id="Stockholm-icons-/-General-/-Folder" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <rect id="bound" x="0" y="0" width="24" height="24"></rect>
        <path d="M3.5,20 L20.5,20 C21.3284271,20 22,19.3284271 22,18.5 L22,8.5 C22,7.67157288 21.3284271,7 20.5,7 L11,7 L8.43933983,4.43933983 C8.15803526,4.15803526 7.77650439,4 7.37867966,4 L3.5,4 C2.67157288,4 2,4.67157288 2,5.5 L2,18.5 C2,19.3284271 2.67157288,20 3.5,20 Z" id="Path-5" fill="#000000"></path>
    </g>
</svg>
